import { Helmet } from 'react-helmet-async';
// sections
import { EditLoSamView } from 'src/sections/losam/view';

// ----------------------------------------------------------------------

export default function LoSamEditPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị:Chỉnh sửa lô sâm</title>
      </Helmet>

      <EditLoSamView />
    </>
  );
}
